import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";
import { withRouter } from "react-router-dom";
import LayoutContainer from "../screens/layout/admin-dashboard";
import MessageConfigurationProfile from "../screens/masters/messageConfiguration/messageConfigurationProfile";
import queryString from "query-string";
const Home = props => {
  const breadCrumbData = [
    { link: "/masters-list", name: "Masters" },
    { link: "/messageConfiguration-list", name: "Message Configuration" },
    {
      link: `/messageConfiguration-profile`,
      name: ` Message Configuration Detail-${
        queryString.parse(props.location.search).id
      }`
    }
  ];
  return (
    <>
      <LayoutContainer>
        <BreadCrumb data={breadCrumbData} />
        <MessageConfigurationProfile />
      </LayoutContainer>
    </>
  );
};

export default withRouter(Home);
